import { Page, PageContent } from "@/shared/components/ui/Page";
import { PageHeader, PageHeaderAction } from "@/shared/components/ui/PageHeader";
import { useAppNavigation } from "@/shared/hooks/useAppNavigation";
import { ClientsList } from "../components/ClientsList";

export function ClientsListPage() {
  const { goToClientAdd, goToClientDetails } = useAppNavigation();
  return (
    <Page>
      <PageHeader title="Customers" actions={<PageHeaderAction aria-label="Add customer" onClick={goToClientAdd}>Add</PageHeaderAction>} />
      <PageContent>
        <ClientsList onClientClick={(client) => goToClientDetails(client.id)} onAddClient={goToClientAdd} />
      </PageContent>
    </Page>
  );
}
